export enum UploadStatus {
  unknown = 'UNKNOWN',
  success = 'SUCCESS',
  failed = 'FAILED',
  // for situations like file too big
  // or invalid extension
  failedPerm = 'FAILED_PERMANENTLY',
}

export function isUploadStatusSuccess(
  status: UploadStatus | undefined
): status is UploadStatus.success {
  return status === UploadStatus.success;
}

export function isUploadStatusFailed(
  status: UploadStatus | undefined
): status is UploadStatus.failed {
  return status === UploadStatus.failed;
}
